import Head from "next/head";
import PropTypes from "prop-types";
import { IGetGovernmentQuery } from "../../lib/queries/__generated__/GetGovernmentQuery.generated";

interface IGovernmentHelmetProps {
  government: NonNullable<IGetGovernmentQuery["government"]>;
}
export default function GovernmentHelmet({ government }: IGovernmentHelmetProps) {
  return (
    <Head>
      <title>{government.name}</title>

      <meta name="twitter:title" content={government.city.name} />
      <meta property="og:title" content={government.city.name} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@Govlaunch" />

      <meta name="twitter:image" content={government.logo || ""} />
      <meta property="og:image" content={government.logo || ""} />

      <meta
        name="twitter:description"
        content={`${getCityType(government.city.governmentType)} in ${government.city.state}`}
      />

      <meta
        property="og:description"
        content={`${getCityType(government.city.governmentType)} in ${government.city.state}`}
      />

      <meta name="description" content={`${getCityType(government.city.governmentType)} in ${government.city.state}`} />
    </Head>
  );
}

GovernmentHelmet.propTypes = {
  government: PropTypes.object.isRequired
};

function getCityType(governmentType: string) {
  if (governmentType === "county") {
    return "County";
  }
  if (governmentType === "township") {
    return "Township";
  }
  return "City";
}
